var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { CampaignService } from './campaign.service';
var CampaignConfirmComponent = /** @class */ (function (_super) {
    __extends(CampaignConfirmComponent, _super);
    function CampaignConfirmComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.defMode = '';
        _this.confirmData = {};
        _this.confirmKey = [
            'type',
            'target_campaign_name',
            'registry_type_name',
            'behavior_name',
            'is_campaign_act',
            'elapsed_date',
            'within_date',
            'trigger_name',
            'send_reserve_date'
        ];
        _this.execEstimate = false;
        _this.typeKey = '';
        _this.target = '';
        return _this;
    }
    CampaignConfirmComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
    };
    CampaignConfirmComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        if (this.component.params && this.component.params.mode) {
            this.defMode = this.component.params.mode;
        }
    };
    CampaignConfirmComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    CampaignConfirmComponent.prototype.onSubscribe = function (data) {
        this.typeKey = data.campaign_timing.type;
        if (data.campaign_id) {
            this.getList(data.campaign_id);
        }
    };
    CampaignConfirmComponent.prototype.onModeSubscribe = function (mode) {
        if (this.defMode !== mode) {
            this.action.deleteCompRec(this.componentName);
        }
    };
    CampaignConfirmComponent.prototype.getList = function (id) {
        var _this = this;
        this.confirmData = {};
        this.service.getCampaignConfirm(id).subscribe(function (rec) {
            if (typeof rec !== 'undefined') {
                _this.confirmData = rec;
                // this.target = this.service.getTargetMsg(this.rec, rec['estimate_send_number'],
                // 	this.rec['target_type'] === 'value' ? this.msgSnapshot['CampaignConfirmComponent.label.targetValue'] : this.msgSnapshot['CampaignConfirmComponent.label.targetPercent']);
                // this.segment = rec['estimate_segment'];
                _this.action.setCompRec(_this.componentName, { campaign_id: _this.rec.campaign_id });
            }
        });
    };
    CampaignConfirmComponent.prototype.getEstimate = function () {
        var _this = this;
        this.service.getCampaignEstimate(this.rec.campaign_id).subscribe(function (rec) {
            if (typeof rec !== 'undefined') {
                _this.target = _this.service.getTargetMsg(_this.rec, rec['estimate_send_number'], _this.rec['target_type'] === 'value' ? _this.msgSnapshot['CampaignConfirmComponent.label.targetValue'] : _this.msgSnapshot['CampaignConfirmComponent.label.targetPercent']);
                _this.segment = rec['estimate_segment'];
                _this.execEstimate = true;
            }
        });
    };
    CampaignConfirmComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    CampaignConfirmComponent.prototype.trackBySegment = function (index, segment) {
        return segment.name;
    };
    CampaignConfirmComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'campaign-confirm',
                    template: "<div *ngIf=\"defMode === mode\" id=\"{{ componentName }}\">\n  <div class=\"row\">\n    <div class=\"col-sm-12\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\"><label class=\"formLabelText\">{{ (msg | async)['CampaignConfirmComponent.label.timing'] }}</label></dt>\n        <dd class=\"form_dd\">\n          <ul class=\"-listStyle-slash\">\n            <ng-template ngFor let-key [ngForOf]=\"confirmKey\">\n              <ng-template [ngIf]=\"confirmData[key]\">\n                <li *ngIf=\"key !== 'elapsed_date' && key !== 'within_date'\" class=\"form_li\"><label>{{ confirmData[key] }}</label></li>\n                <li *ngIf=\"key === 'elapsed_date'\" class=\"form_li\"><label>{{ (msg | async)['CampaignConfirmComponent.campaign.elapsedDate.label1'] }}{{ confirmData[key] }}{{ (msg | async)['CampaignConfirmComponent.campaign.elapsedDate.label2'] }}</label></li>\n                <li *ngIf=\"key === 'within_date'\" class=\"form_li\"><label>{{ (msg | async)['CampaignConfirmComponent.campaign.withinDate.label1'] }}{{ confirmData[key] }}{{ (msg | async)['CampaignConfirmComponent.campaign.withinDate.label2'] }}</label></li>\n              </ng-template>\n            </ng-template>\n          </ul>\n        </dd>\n      </dl>\n    </div>\n  </div>\n  <div class=\"row -mt-3\" *ngIf=\"typeKey === 'immediate'\">\n    <div *ngIf=\"execEstimate === false\">\n      <ul class=\"btns\">\n        <li class=\"btns_li\">\n          <button class=\"btn btn-sm\" type=\"button\" (click)=\"getEstimate()\">{{ (msg | async)['CampaignConfirmComponent.label.estimate'] }}</button>\n        </li>\n      </ul>\n    </div>\n    <div class=\"col-sm-12\" *ngIf=\"execEstimate === true\">\n      <dl class=\"form\">\n        <dt class=\"form_dt\"><label class=\"formLabelText\">{{ (msg | async)['CampaignConfirmComponent.label.target'] }}</label></dt>\n        <dd class=\"form_dd\">\n          <ul>\n            <li class=\"form_li\">{{ target }}</li>\n            <li *ngFor=\"let seg of segment; trackBy: trackBySegment\" class=\"form_li form_li-break\">{{ seg.name }}: {{ seg.num }}{{ (msg | async)['CampaignConfirmComponent.label.segment'] }}</li>\n          </ul>\n        </dd>\n      </dl>\n    </div>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    CampaignConfirmComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: CampaignService }
    ]; };
    return CampaignConfirmComponent;
}(ContentBaseComponent));
export { CampaignConfirmComponent };
//# sourceMappingURL=campaign-confirm.component.js.map